<template>
    <section class="v-application-wrap">
    <div class="server-req-container">
        <div class="v-image-contain">
            <figure>
                <img loading="lazy" src="@/assets/images/404-not-found.webp" alt="404-not-found">
            </figure>
        </div>

        <div class="ooops-text-h">
            <h2> Ooops!</h2>
        </div>
        <div class="ooops-text-wrpper">
            <p>What are the odds of that?</p>
            <p>We can't seem to find the page you're looking for.</p>
        </div>
        <div class="go-to-back-btn">
            <a @click="$router.back()" title="Go Back" role="button" href="javascript:void(0)"> 
                <img loading="lazy" src="@/assets/images/back-arrow.webp" alt="back-arrow">
                Back to home
            </a>
        </div>
    </div>
        
   </section>
</template>

<script>
export default {

}
</script>